module.exports = __webpack_public_path__ + "img/10.cacd7c1c.png";